import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

const LANGS = ':lang(' + ['ru', 'en', 'zh', 'pt', 'es', 'my', 'pl'].join('|') + ')?';
const URLS = {
  [`/main/citymailing`] : '/main',
  [`/main/mailing`] : '/main',
  [`/main/travel_form`] : '/main',
  [`/main/publisher/citymailing`] : '/main/publisher',
  [`/main/publisher/travel_form`] : '/main/publisher',
  [`/main/advertiser/citymailing`] : '/main/advertiser',
  [`/main/advertiser/travel_form`] : '/main/advertiser',

  [`/main/${LANGS}/start/webmasters`] : '/main/register/publisher',
  [`/main/${LANGS}/start/advertisers`] : '/main/register/advertiser',
  [`/main/${LANGS}/events`] : '/main/news',

  [`/main/${LANGS}/company/history`] : '/main/about',
  [`/main/${LANGS}/company/team`] : '/main/about',
  [`/main/${LANGS}/company/clients`] : '/main/about',
  [`/main/${LANGS}/company/contacts`] : '/main/about/contacts',
  [`/main/${LANGS}/company/career`] : '/main/about/vacancy',
  [`/main/${LANGS}/company/personal`] : '/main/about/policy',

  [`/main/${LANGS}/web-solutions/webmasters`] : '/main/about/policy',
  [`/main/${LANGS}/web-solutions/e-mail-retargeting`] : '/main',
  [`/main/${LANGS}/web-solutions/catalogue`] : '/main/publisher/product_feed',
  [`/main/${LANGS}/web-solutions`] : '/main/publisher',

  [`/main/${LANGS}/adv-solutions/e-mail-retargeting`] : '/main',
  [`/main/${LANGS}/adv-solutions/recommends`] : '/main/advertiser/big_data',
  [`/main/${LANGS}/adv-solutions`] : '/main/advertiser',

  [`/main/${LANGS}/platform/dmp`] : '/main/big_data',
  [`/main/${LANGS}/platform/dco`] : '/main/big_data',
  [`/main/${LANGS}/platform/recommends`] : '/main/big_data',
  [`/main/${LANGS}/platform/emailing`] : '/main',
  [`/main/${LANGS}/platform`] : '/main',
}

export default class OldUrls extends Component {

  render() {
    return (
      <Switch>
        {Object.keys(URLS).map(path => (
          <Route key={path} path={path} render={() => (
            <Redirect to={URLS[path]}/>
          )}/>
        ))}
      </Switch>
    );
  }

}
